import React from 'react';
import { toast } from 'react-toastify';
export const useMessage = () => {
    return React.useCallback((text, type) => {
        toast[type](text, {
            position: 'top-right',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        });
    }, []);
};
